"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getBinPaths () {
        return getBinPaths;
    },
    get getBinScripts () {
        return getBinScripts;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _os = /*#__PURE__*/ _interop_require_default(require("os"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function findUp(name, dir) {
    let currentDir = dir;
    while(currentDir !== "/"){
        const fullPath = _path.default.join(currentDir, name);
        if (_fs.default.existsSync(fullPath)) {
            return fullPath;
        }
        currentDir = _path.default.dirname(currentDir);
    }
    return undefined;
}
function getBinPaths() {
    const bins = _os.default.platform() === "win32" ? [
        "lage.cmd",
        "lage-server.cmd"
    ] : [
        "lage",
        "lage-server"
    ];
    const binPaths = bins.map((bin)=>findUp("node_modules/.bin/" + bin, __dirname));
    if (binPaths.some((binPath)=>binPath === undefined)) {
        throw new Error("Could not find bin paths for lage or lage-server");
    }
    return {
        lage: binPaths[0],
        "lage-server": binPaths[1]
    };
}
function getBinScripts() {
    const thisPackageJsonPath = findUp("package.json", __dirname);
    if (!thisPackageJsonPath) {
        throw new Error("Could not find package.json of this packageF");
    }
    const thisPackagePath = _path.default.dirname(thisPackageJsonPath);
    if (_fs.default.existsSync(_path.default.join(thisPackagePath, "dist", "lage.js"))) {
        // the case for CLI package after build
        return {
            lage: _path.default.join(thisPackagePath, "dist", "lage.js"),
            "lage-server": _path.default.join(thisPackagePath, "dist", "lage-server.js")
        };
    } else {
        // the case for CLI package during development
        return {
            lage: _path.default.join(thisPackagePath, "bin", "lage.js"),
            "lage-server": _path.default.join(thisPackagePath, "bin", "lage-server.js")
        };
    }
}
